import React from 'react'

import BaseBridge from 'config/bridge/BaseBridge'
import { defaultError } from 'mocks/ResponseError'
import { FallbackProps } from 'react-error-boundary'

import { ErrorPage } from './ErrorPage/ErrorPage'

export const FallbackError: React.FC<FallbackProps> = ({ resetErrorBoundary }) => {
  const goBack = () => BaseBridge.requestGoBack()

  const page = (
    <ErrorPage
      title={defaultError.title}
      subTitle={defaultError.subTitle}
      goHome={goBack}
      done={resetErrorBoundary}
    />
  )

  return <>{page}</>
}
